import { API } from '../Api';

export type ProfileImageType = 'avatar' | 'cover';

// Lý do (khớp enum ReportPostValue của BE)
export const IMAGE_REPORT_REASONS: { value: number; label: string }[] = [
  { value: 1, label: 'Nội dung không phù hợp' },
  { value: 9, label: 'Nội dung nhạy cảm / khiêu dâm' },
  { value: 3, label: 'Bạo lực' },
  { value: 4, label: 'Quấy rối' },
  { value: 8, label: 'Nguy hại trẻ em' },
  { value: 10, label: 'Khác' },
];

export const reportProfileImage = (payload: {
  targetUserId: string;
  imageType: ProfileImageType;
  reason: number;
  content?: string;
}) => {
  // Gateway route ReportController "lách" version: {version}=report → /api/report/...
  // (khớp pattern create-report hiện có, vì ReportController ở /api/Report không có /v1)
  return API.post<boolean>('/report/user-service/report-profile-image', {
    targetUserId: payload.targetUserId,
    imageType: payload.imageType,
    reason: payload.reason,
    content: payload.content ?? '',
  }).then((res) => res.data);
};

// ----- Admin -----
export interface ProfileImageReport {
  id: string;
  targetUserId: string;
  targetUserName?: string;
  imageType: ProfileImageType;
  imageUrl?: string;
  reportByUserId: string;
  reportByUserName?: string;
  reason: number;
  content?: string;
  stateReport: number; // 0 Pending, 1 Accepted, 2 Rejected
  createdAt: string;
}

export const getProfileImageReports = (
  state?: number,
  pageNumber = 1,
  pageSize = 20
) => {
  const params: Record<string, number> = { pageNumber, pageSize };
  if (state !== undefined) params.state = state;
  return API.get<ProfileImageReport[]>(
    '/v1/user-service/admin/ReportProfileImage/list',
    { params }
  ).then((res) => res.data ?? []);
};

export const handleProfileImageReport = (reportId: string, accept: boolean) => {
  return API.post<boolean>(
    '/v1/user-service/admin/ReportProfileImage/handle',
    { reportId, accept }
  ).then((res) => res.data);
};
